// BattingStats.js
import React, { useState, useEffect ,useCallback} from 'react';

const BattingStats = ({
    competitionId,
    statsFeed,
    onError
}) => {
    const [loading, setLoading] = useState(false);
    // const [battingStats, setBattingStats] = useState([]);
    const [selectedStat, setSelectedStat] = useState('toprunsscorers');
    const [allStats, setAllStats] = useState({});
    const [isInitialized, setIsInitialized] = useState(false);
    const feedURL = process.env.REACT_APP_FEED_URL;

    const statEndpoints = {
        'Most Runs': 'toprunsscorers',
        'Highest Individual Score': 'highestindividualscorers',
        'Highest Strike Rate(T)': 'higheststrikeratetournament',
        'Highest Strike Rate(I)': 'higheststrikerateinnings',
        'Highest Averages': 'highestaverages',
        'Most Sixes': 'mostsixes',
        'Most Sixes (Innings)': 'mostsixesinnings',
        'Most Fours': 'mostfours',
        'Most Fours (Innings)': 'mostfoursinnings',
        'Most Fifties': 'mostfifties',
        'Most Centuries': 'mostcenturies',
        'Fastest Fifties': 'fastestfifties',
        'Fastest Centuries': 'fastestcenturies'
    };

    const columnConfigs = {
        toprunsscorers: {
            headers: [
                { key: 'pos', label: 'POS' },
                { key: 'player', label: 'PLAYER' },
                { key: 'team', label: 'TEAM' },
                { key: 'matches', label: 'M' },
                { key: 'totalruns', label: 'R' },
                { key: 'innings', label: 'I' },
                { key: 'notouts', label: 'NO' },
                { key: 'highscore', label: 'HS' },
                { key: 'battingaverage', label: 'AVG' },
                { key: 'ballsfaced', label: 'BF' },
                { key: 'strikerate', label: 'SR' },
                { key: 'hundreds', label: '100' },
                { key: 'fifty', label: '50' },
                { key: 'fours', label: '4S' },
                { key: 'sixes', label: '6S' }
            ]
        },
        highestindividualscorers: {
            headers: [
                { key: 'pos', label: 'POS' },
                { key: 'player', label: 'PLAYER' },
                { key: 'team', label: 'TEAM' },
                { key: 'highscore', label: 'HS' },
                { key: 'ballsfaced', label: 'BF' },
                { key: 'fours', label: '4S' },
                { key: 'sixes', label: '6S' },
                { key: 'strikerate', label: 'SR' },
                { key: 'against', label: 'AGAINST' },
                { key: 'venue', label: 'VENUE' },
                { key: 'date', label: 'DATE' }
            ]
        },
        higheststrikeratetournament: {
            headers: [
                { key: 'pos', label: 'POS' },
                { key: 'player', label: 'PLAYER' },
                { key: 'team', label: 'TEAM' },
                { key: 'matches', label: 'M' },
                { key: 'strikerate', label: 'SR' },
                { key: 'innings', label: 'I' },
                { key: 'notouts', label: 'NO' },
                { key: 'totalruns', label: 'R' },
                { key: 'highscore', label: 'HS' },
                { key: 'battingaverage', label: 'AVG' },
                { key: 'ballsfaced', label: 'BF' },
                { key: 'hundreds', label: '100' },
                { key: 'fifty', label: '50' },
                { key: 'fours', label: '4S' },
                { key: 'sixes', label: '6S' },

            ]
        },
        higheststrikerateinnings: {
            headers: [
                { key: 'pos', label: 'POS' },
                { key: 'player', label: 'PLAYER' },
                { key: 'team', label: 'TEAM' },
                { key: 'strikerate', label: 'SR' },
                { key: 'totalruns', label: 'R' },
                { key: 'ballsfaced', label: 'BF' },
                { key: 'fours', label: '4S' },
                { key: 'sixes', label: '6S' },
                { key: 'against', label: 'AGAINST' },
                { key: 'venue', label: 'VENUE' },
                { key: 'date', label: 'DATE' }
            ]
        },

        highestaverages: {
            headers: [
                { key: 'pos', label: 'POS' },
                { key: 'player', label: 'PLAYER' },
                { key: 'team', label: 'TEAM' },
                { key: 'matches', label: 'M' },
                { key: 'battingaverage', label: 'AVG' },
                { key: 'innings', label: 'I' },
                { key: 'notouts', label: 'NO' },
                { key: 'totalruns', label: 'R' },
                { key: 'highscore', label: 'HS' },
                { key: 'ballsfaced', label: 'BF' },
                { key: 'strikerate', label: 'SR' },
                { key: 'hundreds', label: '100' },
                { key: 'fifty', label: '50' },
                { key: 'fours', label: '4S' },
                { key: 'sixes', label: '6S' }
            ]
        },
        mostsixes: {
            headers: [
                { key: 'pos', label: 'POS' },
                { key: 'player', label: 'PLAYER' },
                { key: 'team', label: 'TEAM' },
                { key: 'matches', label: 'M' },
                { key: 'sixes', label: '6S' },
                { key: 'innings', label: 'I' },
                { key: 'notouts', label: 'NO' },
                { key: 'totalruns', label: 'R' },
                { key: 'highscore', label: 'HS' },
                { key: 'battingaverage', label: 'AVG' },
                { key: 'ballsfaced', label: 'BF' },
                { key: 'strikerate', label: 'SR' },
                { key: 'hundreds', label: '100' },
                { key: 'fifty', label: '50' },
                { key: 'fours', label: '4S' }
            ]
        },
        mostsixesinnings: {
            headers: [
                { key: 'pos', label: 'POS' },
                { key: 'player', label: 'PLAYER' },
                { key: 'team', label: 'TEAM' },
                { key: 'matches', label: 'M' },
                { key: 'sixes', label: '6S' },
                { key: 'innings', label: 'I' },
                { key: 'notouts', label: 'NO' },
                { key: 'totalruns', label: 'R' },
                { key: 'battingaverage', label: 'AVG' },
                { key: 'ballsfaced', label: 'BF' },
                { key: 'strikerate', label: 'SR' },
                { key: 'hundreds', label: '100' },
                { key: 'fifty', label: '50' },
                { key: 'fours', label: '4S' }
            ]
        },
        mostfours: {
            headers: [
                { key: 'pos', label: 'POS' },
                { key: 'player', label: 'PLAYER' },
                { key: 'team', label: 'TEAM' },
                { key: 'matches', label: 'M' },
                { key: 'fours', label: '4S' },
                { key: 'innings', label: 'I' },
                { key: 'notouts', label: 'NO' },
                { key: 'totalruns', label: 'R' },
                { key: 'highscore', label: 'HS' },
                { key: 'battingaverage', label: 'AVG' },
                { key: 'ballsfaced', label: 'BF' },
                { key: 'strikerate', label: 'SR' },
                { key: 'hundreds', label: '100' },
                { key: 'fifty', label: '50' },
                { key: 'sixes', label: '6S' }
            ]
        },
        mostfoursinnings: {
            headers: [
                { key: 'pos', label: 'POS' },
                { key: 'player', label: 'PLAYER' },
                { key: 'team', label: 'TEAM' },
                { key: 'fours', label: '4S' },
                { key: 'innings', label: 'I' },
                { key: 'notouts', label: 'NO' },
                { key: 'totalruns', label: 'R' },
                { key: 'battingaverage', label: 'AVG' },
                { key: 'ballsfaced', label: 'BF' },
                { key: 'strikerate', label: 'SR' },
                { key: 'hundreds', label: '100' },
                { key: 'fifty', label: '50' },
                { key: 'sixes', label: '6S' }
            ]
        },
        mostfifties: {
            headers: [
                { key: 'pos', label: 'POS' },
                { key: 'player', label: 'PLAYER' },
                { key: 'team', label: 'TEAM' },
                { key: 'matches', label: 'M' },
                { key: 'fifty', label: '50' },
                { key: 'innings', label: 'I' },
                { key: 'notouts', label: 'NO' },
                { key: 'totalruns', label: 'R' },
                { key: 'highscore', label: 'HS' },
                { key: 'battingaverage', label: 'AVG' },
                { key: 'ballsfaced', label: 'BF' },
                { key: 'strikerate', label: 'SR' },
                { key: 'hundreds', label: '100' },
                { key: 'fours', label: '4S' },
                { key: 'sixes', label: '6S' }
            ]
        },
        mostcenturies: {
            headers: [
                { key: 'pos', label: 'POS' },
                { key: 'player', label: 'PLAYER' },
                { key: 'team', label: 'TEAM' },
                { key: 'matches', label: 'M' },
                { key: 'hundreds', label: '100' },
                { key: 'innings', label: 'I' },
                { key: 'notouts', label: 'NO' },
                { key: 'totalruns', label: 'R' },
                { key: 'highscore', label: 'HS' },
                { key: 'battingaverage', label: 'AVG' },
                { key: 'ballsfaced', label: 'BF' },
                { key: 'strikerate', label: 'SR' },
                { key: 'fifty', label: '50' },
                { key: 'sixes', label: '6S' },
                { key: 'fours', label: '4S' },
            ]
        },
        fastestfifties: {
            headers: [
                { key: 'pos', label: 'POS' },
                { key: 'player', label: 'PLAYER' },
                { key: 'team', label: 'TEAM' },
                { key: 'fiftyballs', label: 'BALLS' },
                { key: 'against', label: 'OPPOSITION' },
                { key: 'venue', label: 'VENUE' },
                { key: 'date', label: 'DATE' },
                { key: 'sixes', label: '6S' },
                { key: 'fours', label: '4S' },
                { key: 'totalruns', label: 'TOTAL' }
            ]
        },
        fastestcenturies: {
            headers: [
                { key: 'pos', label: 'POS' },
                { key: 'player', label: 'PLAYER' },
                { key: 'team', label: 'TEAM' },
                { key: 'fiftyballs', label: 'BALLS' },
                { key: 'against', label: 'OPPOSITION' },
                { key: 'venue', label: 'VENUE' },
                { key: 'date', label: 'DATE' },
                { key: 'sixes', label: '6S' },
                { key: 'fours', label: '4S' },
                { key: 'totalruns', label: 'TOTAL' }
            ]
        }
    };

    const fetchBattingStats = async (endpoint) => {
        if (!competitionId) return null;

        try {
            const timestamp = new Date().getTime();
            const defaultFeed = `${feedURL}`;
            const url = `${statsFeed || defaultFeed}/stats/${competitionId}-${endpoint}.js?callback=on${endpoint}&_=${timestamp}`;

            const response = await fetch(url);
            if (!response.ok) {
                console.error(`HTTP error for ${endpoint}! status: ${response.status}`);
                return null;
            }
            
            let text = await response.text();
            
            // Remove the callback wrapper
            text = text.replace(new RegExp(`^on${endpoint}\\(|\\);?$`, 'g'), '');
            
            try {
                const data = JSON.parse(text);
                
                // Find the correct data array
                let playerData = [];
                if (Array.isArray(data)) {
                    playerData = data;
                } else if (typeof data === 'object') {
                    // Look for arrays in the object
                    const arrayKeys = Object.keys(data).filter(key => Array.isArray(data[key]));
                    if (arrayKeys.length > 0) {
                        playerData = data[arrayKeys[0]];
                    }
                }

                if (!playerData.length) {
                    console.warn(`No player data found for ${endpoint}`);
                    return [];
                }

                return playerData.map(player => ({
                    player: player.StrikerName || '',
                    team: player.TeamName || '',
                    matches: player.Matches || '0',
                    totalruns: player.TotalRuns || '0',
                    innings: player.Innings || '0',
                    notouts: player.NotOuts || '0',
                    highscore: player.HighestScore || '0',
                    battingaverage: player.BattingAverage || '0',
                    ballsfaced: player.Balls || '0',
                    strikerate: player.StrikeRate || '0',
                    hundreds: player.Centuries || '0',
                    fifty: player.FiftyPlusRuns || '0',
                    fours: player.Fours || '0',
                    sixes: player.Sixes || '0',
                    against: player.AgainstTeamName || '',
                    venue: player.VenueName || '',
                    date: player.MatchDate ? formatDate(player.MatchDate) : '',
                    fiftyballs: player.FiftyBalls || '0'
                }));

            } catch (parseError) {
                console.error(`Error parsing JSON for ${endpoint}:`, parseError);
                return null;
            }
        } catch (err) {
            console.error(`Error fetching ${endpoint}:`, err);
            return null;
        }
    };

    const fetchAllStatsConcurrently = useCallback(async () => {
        if (!competitionId || isInitialized) return;

        setLoading(true);
        const endpoints = Object.values(statEndpoints);
        
        try {
            const fetchPromises = endpoints.map(endpoint => 
                fetchBattingStats(endpoint)
                    .then(data => ({ endpoint, data }))
                    .catch(() => ({ endpoint, data: [] }))
            );

            const results = await Promise.allSettled(fetchPromises);
            
            const newStats = results.reduce((acc, result) => {
                if (result.status === 'fulfilled' && result.value.data) {
                    acc[result.value.endpoint] = result.value.data;
                } else {
                    acc[result.value.endpoint] = [];
                }
                return acc;
            }, {});

            setAllStats(newStats);
            setIsInitialized(true);
        } catch (error) {
            console.error('Error fetching stats:', error);
            onError?.('Failed to load stats');
        } finally {
            setLoading(false);
        }
    }, [competitionId, statsFeed, isInitialized]);

    const handleStatChange = (event) => {
        event.preventDefault();
        const dropdownValue = event.target.value;
        const endpoint = statEndpoints[dropdownValue];
        
        requestAnimationFrame(() => {
            setSelectedStat(endpoint);
        });
    };

    useEffect(() => {
        fetchAllStatsConcurrently();
    }, [fetchAllStatsConcurrently]);

    const formatDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString.split('T')[0]);
        const months = ['January', 'February', 'March', 'April', 'May', 'June', 
                       'July', 'August', 'September', 'October', 'November', 'December'];
        return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
    };

    if (loading && !isInitialized) {
        return <div>Loading stats...</div>;
    }

    const currentStats = allStats[selectedStat] || [];

    return (
        <div id="mcTourBattingStats" className="tabTourContent current">
            <div className="otherStats">
                <select
                    className="mcSelectDefault otherStatsFilter"
                    onChange={handleStatChange}
                    value={Object.keys(statEndpoints).find(key => 
                        statEndpoints[key] === selectedStat
                    )}
                >
                    {Object.keys(statEndpoints).map(option => (
                        <option key={option} value={option}>
                            {option}
                        </option>
                    ))}
                </select>
            </div>

            <div className="nicescroll_content tmtBatStatsContent js-statsTableWrap" tabIndex="5">
                <table className="mcTableDefault batCardTable" cellSpacing="0" cellPadding="0" border="0">
                    {currentStats.length > 0 ? (
                        <>
                            <thead>
                                <tr>
                                    {(columnConfigs[selectedStat] || columnConfigs.toprunsscorers).headers.map(header => (
                                        <th key={header.key}>{header.label}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {currentStats.map((stat, index) => (
                                    <tr key={index}>
                                        {(columnConfigs[selectedStat] || columnConfigs.toprunsscorers).headers.map(header => (
                                            <td key={header.key}>
                                                {header.key === 'pos' ? index + 1 : stat[header.key]}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </>
                    ) : (
                        <tbody>
                            <tr>
                                <td colSpan="15" style={{ textAlign: 'center', padding: '20px' }}>
                                    No data found
                                </td>
                            </tr>
                        </tbody>
                    )}
                </table>
            </div>
        </div>
    );
};

export default BattingStats;